module.exports = __webpack_public_path__ + "img/c6.4899d2c6.jpg";